import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from './AuthProvider';
import { Spinner } from '../components/ui';

/**
 * Gate for the pages that make no sense signed out. It waits for the initial
 * silent refresh to settle before deciding -- redirecting during that window
 * would bounce a signed-in user to the login page on every cold load.
 */
export const RequireAuth = ({ children }: { children: ReactNode }): JSX.Element => {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready) return <Spinner label="Checking your session" />;
  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
};
